import React from "react";

export const GlobalMessage = ({show, message}) => {
    const componentClasses = ['GlobalMessageBox'];
    if (!show) {
        componentClasses.push('hide');
    }

    return (
        <div className={componentClasses.join(' ')}>
        {message}
        </div>
    );
};

export default GlobalMessage;
